module.exports = __webpack_public_path__ + "media/src/assets/images/expand-less-343decc728ee95aca208f55b467a5879.svg";